/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import { memo, Suspense, useEffect } from 'react'

import BannerAds from '@/components/BannerAds'
import Loader from '@/components/Loader'
import { ENVIRONMENT } from '@/utils/constants'
import { UseClientModelContext } from '@mercadoni/sinister/dist/cjs/client/contexts'
import { trackEvent } from '@mercadoni/sinister/dist/cjs/monitors/services'
import { Banners as BannersComponent } from '@mercadoni/sinister/dist/cjs/shared'
import PropTypes from 'prop-types'

const pagetype = 'categories'

interface IBanner {
  id: string
  title: string
  desktopImage: string
  mobileImage: string
}

const Banners = ({ currentCategory, categoryBanners, path, isMobile }: any) => {
  const { enabledAds, adsBanners, clientId } = UseClientModelContext()
  const pageTypeConf = adsBanners?.pagetype ? adsBanners.pagetype : pagetype
  let adsPath = ''
  let adUnit = ''

  if (enabledAds && currentCategory.name) {
    const cleanPath = (strg: string) => strg.split('/').filter((x) => x.length)
    const replace = (strg: string) => strg.split(' ').join('-')
    adsPath = cleanPath(path).reduce((o, c) => `${o}/${replace(c)}`, adsPath)
    adUnit = `${adsBanners?.[pagetype]?.path}${adsPath}`
  }

  // const onClickBanner = useCallback(
  //   (id) => history.push(getRoutingUrl(`/promotion/${id}`)),
  //   []
  // )

  const onClickBanner = () => console.log('onClickBanner') // TODO
  useEffect(() => {
    if (categoryBanners.length) {
      categoryBanners.forEach((banner: IBanner) => {
        trackEvent({
          eventName: 'view_banner',
          data: {
            clientId,
            creative_name: banner?.title || null,
            banner_id: banner?.id || null,
            url: isMobile ? banner?.mobileImage : banner?.desktopImage,
          },
        })
      })
    }
  }, [categoryBanners])

  return (
    <div className="banners">
      <Suspense fallback={<Loader />}>
        {enabledAds && currentCategory.name && (
          <BannerAds
            shapeSquare
            id={adsBanners[pagetype].id}
            path={adUnit}
            size={adsBanners[pagetype].size}
            aspectRatio={adsBanners[pagetype].aspectRatio}
            pagetype={pageTypeConf}
            searchterm={currentCategory.name}
            showLoad={false}
            extraTargeting={{
              env: ENVIRONMENT === 'production' ? 'production' : 'staging',
            }}
          />
        )}
        {!(enabledAds && currentCategory.name && categoryBanners.length) && (
          <BannersComponent banners={categoryBanners} onClick={onClickBanner} />
        )}
      </Suspense>
    </div>
  )
}

Banners.propTypes = {
  currentCategory: PropTypes.object,
  categoryBanners: PropTypes.array,
  path: PropTypes.string,
  isMobile: PropTypes.bool,
}

Banners.defaultProps = {
  categoryBanners: [],
  currentCategory: {},
  path: '',
  isMobile: false,
}

export default memo(Banners)
